/*
 *  I14V3VREGULCalcul.js
 *
 *  Created by Sébastien Hecart on 2017-12-19 16:48:13 +0000.
 *  Copyright © 2017 Sebastien Hecart. All rights reserved.
 *
 *
 */

import { fetchPerteChargeUnite } from '@batical/data/src'
import { I14V3VREGUL_State } from '@batical/types/src'
//TODO IF REQUIREDimport {} from '@batical/types/src';
function I14V3VREGUL_docalcul(state: I14V3VREGUL_State) {
  state.invalidated = false
  const selectedperteCharg_uuid = fetchPerteChargeUnite(state.perteCharg_uuid)
  //TODO CALCUL
  state.res_pdcVanne = Math.pow(state.in_debitCircuit / state.in_kvVanne, 2) * 98
  //res_pdcVann is calculated in kpa/m facto 0.001
  if (selectedperteCharg_uuid) {
    state.res_pdcVanne = (state.res_pdcVanne / 0.001) * selectedperteCharg_uuid.factor
  }
  state.res_autoriteA = state.res_pdcVanne / (state.res_pdcVanne + state.in_pdcReseau)
  return state
}

export default I14V3VREGUL_docalcul
